/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Benefit_Exclusive_ContentInputs */

const en_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early access to new trees and boost your motivation`)
};

const ar_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوصول المبكر إلى الأشجار الجديدة وزيادة حماسك`)
};

const de_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Früher Zugang zu neuen Bäumen und mehr Motivation`)
};

const es_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accede antes a nuevos árboles y aumenta tu motivación`)
};

const fr_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès anticipé à de nouveaux arbres et boostez votre motivation`)
};

const it_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso anticipato a nuovi alberi e aumento della motivazione`)
};

const ja_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい樹種に早期アクセスして、モチベーションをアップ`)
};

const ko_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신상 나무를 누구보다 먼저 심고 동기부여를 얻을 수 있어요`)
};

const pt_br_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso antecipado a novas espécies para aumentar sua motivação`)
};

const ru_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранний доступ к новым деревьям и повышение вашей мотивации`)
};

const th_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าถึงต้นไม้ใหม่ได้ก่อนใคร และเพิ่มแรงบันดาลใจของคุณ`)
};

const tr_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni ağaçlara erken erişim sağla ve motivasyonunu artır`)
};

const zh_cn_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抢先体验独家新树种，动力加倍`)
};

const zh_tw_onboarding_paywall_benefit_exclusive_content = /** @type {(inputs: Onboarding_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搶先體驗獨家新樹種，動力加倍`)
};

/**
* | output |
* | --- |
* | "Early access to new trees and boost your motivation" |
*
* @param {Onboarding_Paywall_Benefit_Exclusive_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_benefit_exclusive_content = /** @type {((inputs?: Onboarding_Paywall_Benefit_Exclusive_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Benefit_Exclusive_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_benefit_exclusive_content(inputs)
	if (locale === "ar") return ar_onboarding_paywall_benefit_exclusive_content(inputs)
	if (locale === "de") return de_onboarding_paywall_benefit_exclusive_content(inputs)
	if (locale === "es") return es_onboarding_paywall_benefit_exclusive_content(inputs)
	if (locale === "fr") return fr_onboarding_paywall_benefit_exclusive_content(inputs)
	if (locale === "it") return it_onboarding_paywall_benefit_exclusive_content(inputs)
	if (locale === "ja") return ja_onboarding_paywall_benefit_exclusive_content(inputs)
	if (locale === "ko") return ko_onboarding_paywall_benefit_exclusive_content(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_benefit_exclusive_content(inputs)
	if (locale === "ru") return ru_onboarding_paywall_benefit_exclusive_content(inputs)
	if (locale === "th") return th_onboarding_paywall_benefit_exclusive_content(inputs)
	if (locale === "tr") return tr_onboarding_paywall_benefit_exclusive_content(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_benefit_exclusive_content(inputs)
	return zh_tw_onboarding_paywall_benefit_exclusive_content(inputs)
});